/**
 * Created by Vladislav on 18.09.2024.
 */

cleverapps.InitConfigByType["board"] = function () {
    Families.initialize();
};